module.exports = __webpack_public_path__ + "static/media/ios-globe.f74670c8.svg";